import React, { useMemo } from "react";
import Button from "./basic/Button";
import { ReactComponent as HeartFillSVG } from "../inline-svg/heart-fill.svg";
import { ReactComponent as HeartSVG } from "../inline-svg/heart.svg";
import { useFavorites } from "../hooks/useApi";
import Loader from "./basic/Loader";
import "../styles/favorite-button.scss";

const FavoriteButton = ({ songid, as }) => {
  const {
    data: favorites,
    isLoading,
    addFavorite,
    removeFavorite,
    isMutating,
  } = useFavorites();

  const cfid = useMemo(() => {
    if (favorites) {
      const found = favorites.find((favorite) => favorite.songid === songid);
      if (found !== undefined) {
        return found.cfid;
      }
    }
    return undefined;
  }, [songid, favorites]);

  const handleToggleFavorite = (e) => {
    e.stopPropagation();
    if (cfid !== undefined) {
      removeFavorite(songid);
    } else {
      addFavorite(songid);
    }
  };

  if (as === "div") {
    return (
      <div className="heart button as-transparent normal">
        {isLoading || isMutating ? (
          <Loader />
        ) : cfid ? (
          <HeartFillSVG />
        ) : (
          <HeartSVG />
        )}
      </div>
    );
  }
  return (
    <Button className="heart" onClick={handleToggleFavorite} as="transparent">
      {isLoading || isMutating ? (
        <Loader />
      ) : cfid ? (
        <HeartFillSVG />
      ) : (
        <HeartSVG />
      )}
    </Button>
  );
};

export default FavoriteButton;
